import { every, findIndex, isEmpty } from 'lodash';
import moment from 'moment';
import queryString from 'query-string';

import * as types from './constants';
import { sorts } from '../../../pages/Performance/components/CreatorsTab/sort';
import { generateQueryFromString, removeFromQueryString } from '../../../utils/queryString';

const initialDate = () => {
  const currentDate = moment(new Date());
  const startSubtract = currentDate.clone().startOf('day').subtract(30, 'days').format();

  return { key: 'date', filterTitle: 'Date', selected: false, value: { since: startSubtract, until: currentDate.endOf('day').format(), type: 'last_days', number: 30 } };
};

export const initialState = {
  listData: {
    dataTable: [],
    allSelected: false,
    apiFilters: null,
    // campaign_modifiers: [],
    loading: false,
    tagsLoading: false,
    count: 0,
    next: null,
    previous: null,
    curr_page: 1,
    errors_api: {},
    queryParsed: false,
    message: null,
    tags: [],
    filters: [
      { ...initialDate() },
      { key: 'users', filterTitle: 'Users', selected: false, value: [] },
      // { key: 'tags', filterTitle: 'Tags', selected: false, value: [] },
      { key: 'campaigns', filterTitle: 'Bonuses', selected: false, value: [] },
      { key: 'lookbooks', filterTitle: 'Lookbooks', selected: false, value: [] },
      { key: 'discount_codes', filterTitle: 'Discount codes', selected: false, value: [] },
      { key: 'connected_since', filterTitle: 'Connected in last 7 days', selected: false, value: false },
      { key: 'active_links_range', filterTitle: 'Active Links', selected: false, value: { min: '', max: '' } },
      { key: 'clicks_range', filterTitle: 'Clicks', selected: false, value: { min: '', max: '' } },
      { key: 'gmv_range', filterTitle: 'Sales', selected: false, value: { min: '', max: '' } },
      { key: 'sort', filterTitle: 'Sort', selected: true, value: sorts.default }
    ]
  }
};

const actions = {

  // Get Performance Creators
  [types.GET_PERFORMANCE_CREATORS_REQUEST]: state => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: true
      }
    };

    return { ...data };
  },

  [types.GET_PERFORMANCE_CREATORS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        allSelected: false,
        loading: false,
        ...payload
      }
    };

    return { ...data };
  },

  [types.GET_PERFORMANCE_CREATORS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: false,
        errors_api: payload
      }
    };

    return { ...data };
  },

  // Operations
  [types.UPDATE_USER_PERFORMANCE_CREATORS]: (state, { payload }) => {
    const newDataTable = state.listData.dataTable.map(el => el.owner_uuid === payload.uuid ? {
      ...el,
      user: payload
    } : el);

    const data = {
      ...state,
      listData: {
        ...state.listData,
        dataTable: newDataTable
      }
    };

    return { ...data };
  },

  [types.TOGGLE_PERFORMANCE_CREATORS]: (state, { payload }) => {
    const newDataTable = state.listData.dataTable.map(el => el.select.id === payload ? {
      ...el,
      select: { ...el.select, value: !el.select.value }
    } : el);

    const status = every(newDataTable, x => x.select.value);

    const data = {
      ...state,
      listData: {
        ...state.listData,
        allSelected: status,
        dataTable: newDataTable
      }
    };

    return { ...data };
  },

  [types.TOGGLE_ALL_PERFORMANCE_CREATORS]: (state, { payload }) => {

    if (payload && payload.reset) {
      const data = {
        ...state,
        listData: {
          ...state.listData,
          allSelected: false,
          dataTable: state.listData.dataTable.map(el => ({
            ...el,
            select: { ...el.select, value: false }
          }))
        }
      };

      return { ...data };
    } else {
      const status = every(state.listData.dataTable, x => x.select.value);

      const data = {
        ...state,
        listData: {
          ...state.listData,
          allSelected: !status,
          dataTable: state.listData.dataTable.map(el => ({
            ...el,
            select: { ...el.select, value: !status }
          }))
        }
      };

      return { ...data };
    }
  },

  [types.SET_PERFORMANCE_CREATORS_FILTER]: (state, { payload }) => {
    const index = findIndex(state.listData.filters, x => x.key === payload.key);
    const updatedFilters = [...state.listData.filters];
    if (index !== -1) {
      updatedFilters[index].value = payload.value;
      if (typeof updatedFilters[index].value === 'string' || Array.isArray(updatedFilters[index].value)) {
        updatedFilters[index].selected = !isEmpty(updatedFilters[index].value);
      } else {
        updatedFilters[index].selected = !isEmpty(updatedFilters[index].value.type);
      }
    }

    const data = {
      ...state,
      listData: {
        ...state.listData,
        filters: updatedFilters,
        curr_page: 1
      }
    };

    return { ...data };
  },

  [types.SET_PERFORMANCE_CREATORS_ALL_FILTERS]: (state, { payload }) => {
    let updatedFilters = [...state.listData.filters];

    payload.forEach(filter => {
      const index = findIndex(updatedFilters, x => x.key === filter.key);
      if (index !== -1) updatedFilters[index] = { ...updatedFilters[index], selected: true, ...filter };
    });

    const data = {
      ...state,
      listData: {
        ...state.listData,
        filters: updatedFilters,
        curr_page: 1,
        queryParsed: true
      }
    };

    return { ...data };
  },

  [types.CLEAR_PERFORMANCE_CREATORS_FILTERS]: (state, { payload: { filterToUpdate, mobile } }) => {
    if (!isEmpty(filterToUpdate)) {
      const index = findIndex(state.listData.filters, x => x.key === filterToUpdate.key);
      const updatedFilters = [...state.listData.filters];
      if (index !== -1) {
        updatedFilters[index].value = filterToUpdate.value;
        updatedFilters[index].selected = filterToUpdate.selected;
      }

      const data = {
        ...state,
        listData: {
          ...state.listData,
          filters: updatedFilters,
          curr_page: 1
        }
      };

      if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}${removeFromQueryString(filterToUpdate.key)}`);

      return { ...data };
    } else {
      const data = {
        ...state,
        listData: {
          ...state.listData,
          filters: initialState.listData.filters,
          curr_page: 1
        }
      };

      const query = generateQueryFromString(window.location.search);

      if (query.tab) {
        if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}?${queryString.stringify({ tab: query.tab })}`);
      } else {
        if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}`);
      }

      return { ...data };
    }
  },

  [types.PERFORMANCE_CREATORS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      listData: {
        ...state.listData,
        curr_page: parseInt(payload) || 1,
        queryParsed: true
      }
    };

    return { ...data };
  },

  [types.PERFORMANCE_CREATORS_ERRORS_RESET]: state => {
    return {
      ...state,
      listData: {
        ...state.listData,
        errors_api: {
          ...initialState.listData.errors_api
        }
      }
    };
  },

  [types.PERFORMANCE_CREATORS_RESET]: () => {
    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

